import React from "react";
import styled from "styled-components";
import { color as c, ColorProps } from "styled-system";
import { Link } from "../Link";
import { Label } from "../Label";
import { theme } from "../../theme";

interface Props {
  to: string;
  color?: string;
  active: boolean;
}

export const StyledLink = styled(Link)<ColorProps>`
  ${c};
  text-decoration: none;
  font-weight: ${theme.fontWeights.normal};
  white-space: nowrap;
`;

const StyledLabel = styled(Label)`
  font-weight: normal;
  white-space: nowrap;
`;
StyledLabel.displayName = "Label";

export const BreadcrumbItem: React.FC<Props> = ({ to, children, color, active }) => (
  <>
    {active ? (
      <StyledLabel color={color}>{children}</StyledLabel>
    ) : (
      <StyledLink color={color} href={to}>
        {children}
      </StyledLink>
    )}
  </>
);

BreadcrumbItem.defaultProps = {
  color: "primary",
};
